module.exports = __webpack_public_path__ + "static/media/googleplayicon.f8c89d23.png";